import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import Landing from "@/pages/Landing";
import ArticlePage from "@/pages/ArticlePage";
import ArchitectureDocs from "@/pages/ArchitectureDocs";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Overview from "@/admin/Overview";
import ContentManager from "@/admin/ContentManager";
import Leads from "@/admin/Leads";
import KnowledgeBase from "@/admin/KnowledgeBase";
import ChatAnalytics from "@/admin/ChatAnalytics";
import CompanySettings from "@/admin/CompanySettings";
import CampaignLayout from "@/admin/campaign/CampaignLayout";
import CampaignOverview from "@/admin/campaign/CampaignOverview";
import TemplateBuilder from "@/admin/campaign/TemplateBuilder";
import CampaignManager, { NewBlast } from "@/admin/campaign/CampaignManager";
import DeliveryLogs from "@/admin/campaign/DeliveryLogs";
import IntegrationSettings from "@/admin/campaign/IntegrationSettings";

function App() {
  return (
    <ErrorBoundary>
    <SiteProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/artikel/:slug" element={<ArticlePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Overview />} />
            <Route path="konten" element={<ContentManager />} />
            <Route path="leads" element={<Leads />} />
            <Route path="knowledge-base" element={<KnowledgeBase />} />
            <Route path="chatbot" element={<ChatAnalytics />} />
            <Route path="pengaturan" element={<CompanySettings />} />
            <Route path="arsitektur" element={<ArchitectureDocs />} />
            <Route path="campaign" element={<CampaignLayout />}>
              <Route index element={<CampaignOverview />} />
              <Route path="templates" element={<TemplateBuilder />} />
              <Route path="campaigns" element={<CampaignManager />} />
              <Route path="campaigns/new" element={<NewBlast />} />
              <Route path="campaigns/:id" element={<NewBlast />} />
              <Route path="logs" element={<DeliveryLogs />} />
              <Route path="settings" element={<IntegrationSettings />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
    </SiteProvider>
    </ErrorBoundary>
  );
}

export default App;
